import React from "react";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import { getVehicleModel } from "../../../model/car";

import { quantityLarger } from "../../common/checkboximage";
import { viewModes } from "../../common/common";
import { VehicleCheckBox, VehicleRadio } from "../../common/checkboximage";
import { TooltipP } from "../../components/tooltip"
import {
	IcChevrDown,
	IcVType,
	IcVMake,
	IcVModel,
	IcTransmission,
	IcFilter3L,
	IcFuel,
	IcResetFilter,
	IcInstantLine,
	IcDelivery,
	IcOwner5Star,
	IcDiscount,
	IcInsuranceLine,
	IcNonMortgage,
	IcElectricCar
} from "../../common/svg";


const VehicleTypesBox = ({ show, onClose, vehicleTypes, onVTypeChange }) => {
	return (
		<Modal
		show={show}
		onHide={() => onClose("isOpenVT")}
		dialogClassName="modal-m modal-fix has-footer modal-confirm">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Loại xe</h5>
		</Modal.Header>
		<Modal.Body>
			<div className="modal-confirm-body carfinding-options-body">
				<div className="vehicle-types">
					{vehicleTypes &&
						vehicleTypes.map((option) => (
							<VehicleCheckBox
								key={option.id.toString()}
								name={`vtm_${option.id}`}
								option={option}
								onVTypeChange={onVTypeChange}
							/>
						))}
				</div>
			</div>
		</Modal.Body>
		<Modal.Footer>
			<div className="wrap-btn">
				<a className="btn btn-primary btn--m" onClick={() => onClose("isOpenVT")}>
					Áp dụng
				</a>
			</div>
		</Modal.Footer>
		</Modal>
	);
};

const VehicleMakesBox = ({ show, vehicleMake, vehicles, onClose, onVehiclesChange }) => {
	return (
		<Modal
			show={show}
			onHide={() => onClose("isOpenVM")}
			dialogClassName="modal-m modal-fix has-footer modal-confirm">
		<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Hãng xe</h5>
		</Modal.Header>
		<Modal.Body>
			<div className="modal-confirm-body carfinding-options-body">
				<div className="vehicle-makes">
					<VehicleRadio vehicles={vehicles} vehicleMake={vehicleMake} onChange={(e) => onVehiclesChange(e)} name={"pc"} />
				</div>
			</div>
		</Modal.Body>
		<Modal.Footer>
			<div className="wrap-btn">
				<a className="btn btn-primary btn--m" onClick={() => onClose("isOpenVM")}>
					Áp dụng
				</a>
			</div>
		</Modal.Footer>
		</Modal>
	);
};


const VehicleModelsBox = ({ show, vehicles, onClose, onVehiclesChange }) => {
	return (
		<Modal
		show={show}
		onHide={() => onClose("isOpenVMD")}
		dialogClassName="modal-m modal-fix has-footer modal-confirm">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Mẫu xe</h5>
		</Modal.Header>
		<Modal.Body>
			<div className="modal-confirm-body carfinding-options-body">
				<div className="vehicle-makes">
					{vehicles &&
						vehicles.map((vehicle) => {
							return vehicle.counter > 0 ? (
								<div key={vehicle.id} className={`custom-checkbox-selected`}>
									<input
										type="checkbox"
										id={`cbMD${vehicle.id}`}
										checked={vehicle.checked}
										onChange={() => onVehiclesChange(vehicle.id)}
									/>
									<label htmlFor={`cbMD${vehicle.id}`}>
										{vehicle.name}
										<span className="note"> ({quantityLarger(vehicle.counter)})</span>
									</label>
								</div>
							) : null;
						})}
				</div>
			</div>
		</Modal.Body>
		<Modal.Footer>
			<div className="wrap-btn">
				<a className="btn btn-primary btn--m" onClick={() => onClose("isOpenVMD")}>
					Áp dụng
				</a>
			</div>
		</Modal.Footer>
		</Modal>
	);
};


const Transmision = ({ show, onTransmissionChange, filter, onClose }) => {
	return (
		<Modal
		show={show}
		onHide={() => onClose("isOpenTrans")}
		dialogClassName="modal-m modal-fix has-footer modal-confirm">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Truyền động</h5>
		</Modal.Header>
		<Modal.Body>
		<div className="modal-confirm-body carfinding-options-body">
			<div className="transmission">
				<div className="custom-radio">
					<input
						type="radio"
						id="cb_trans"
						value="0"
						name="checkbox-trans"
						onChange={onTransmissionChange}
						checked={filter == 0}
					/>
					<label htmlFor="cb_trans">Tất cả</label>
				</div>
				<div className="custom-radio">
					<input
						type="radio"
						id="cb_trans_1"
						value="1"
						name="checkbox-trans"
						onChange={onTransmissionChange}
						checked={filter == 1}
					/>
					<label htmlFor="cb_trans_1">Số tự động</label>
				</div>
				<div className="custom-radio">
					<input
						type="radio"
						id="cb_trans_2"
						value="2"
						name="checkbox-trans"
						onChange={onTransmissionChange}
						checked={filter == 2}
					/>
					<label htmlFor="cb_trans_2">Số sàn</label>
				</div>
			</div>
		</div>
		</Modal.Body>
		<Modal.Footer>
			<div className="wrap-btn">
				<a className="btn btn-primary btn--m" onClick={() => onClose("isOpenTrans")}>
					Áp dụng
				</a>
			</div>
		</Modal.Footer>
		</Modal>
	);
};

const Fuel = ({ show, filter, onFuelChange, onClose }) => {
	return (
		<Modal
		show={show}
		onHide={() => onClose("isOpenFuel")}
		dialogClassName="modal-m modal-dialog modal-confirm">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Nhiên liệu</h5>
		</Modal.Header>
		<Modal.Body>
		<div className="modal-confirm-body carfinding-options-body">
			<div className="fuel">
				<div className="custom-radio">
					<input type="radio" id="r_fuel" name="radio-fuel" value="0" onChange={onFuelChange} checked={filter == 0} />
					<label htmlFor="r_fuel">Tất cả</label>
				</div>
				<div className="custom-radio">
					<input type="radio" id="r_fuel1" name="radio-fuel" value="1" onChange={onFuelChange} checked={filter == 1} />
					<label htmlFor="r_fuel1">Xăng</label>
				</div>
				<div className="custom-radio">
					<input type="radio" id="r_fuel2" name="radio-fuel" value="2" onChange={onFuelChange} checked={filter == 2} />
					<label htmlFor="r_fuel2">Dầu Diesel</label>
				</div>
				<div className="custom-radio">
					<input type="radio" id="r_fuel3" name="radio-fuel" value="3" onChange={onFuelChange} checked={filter == 3} />
					<label htmlFor="r_fuel3">Điện</label>
				</div>
			</div>
			<div className="wrap-btn">
				<a className="btn btn-primary btn--m" onClick={() => onClose("isOpenFuel")}>
					Áp dụng
				</a>
			</div>
		</div>
		</Modal.Body>
		</Modal>
	);
};

class QuicklyFilter extends React.Component {
	constructor() {
		super();
		this.state = {
			isOpenVT: false,
			isOpenVM: false,
			isOpenVMD: false,
			isOpenTrans: false,
			isOpenFuel: false,
			swiperFilter: null,
			isTooltip: false,
		};

		// this.wrapper = React.createRef();
		// this.wrapperVM = React.createRef();
		// this.wrapperVMD = React.createRef();
		// this.wrapperTrans = React.createRef();
		// this.wrapperFuel = React.createRef();
	}

	componentDidMount() {
		const vehicleType = this.props.filter.vehicleType;
		const { vehicleTypes } = this.props;

		if (vehicleTypes) {
			for (let i = 0; i < vehicleTypes.length; ++i) {
				var checked = false;
				if (vehicleType) {
					for (let j = 0; j < vehicleType.length; ++j) {
						if (vehicleTypes[i].id === vehicleType[j]) {
							checked = true;
							break;
						}
					}
				}
				vehicleTypes[i].checked = checked;
			}
		}

		const vehicleMake = this.props.filter.vehicleMake;
		if (vehicleMake > 0) {
			getVehicleModel(vehicleType, vehicleMake, true).then((resp) => {
				if (resp.data.data) {
					this.setState({
						vehicleModels: resp.data.data.vehicleModels,
					});
				}
			});
		}

		// document.addEventListener("click", this.handleClick);
	}

	componentDidUpdate(props, prevState) {
		if (this.props.filter.vehicleType && props.filter.vehicleType != this.props.filter.vehicleType) {
			const vehicleType = this.props.filter.vehicleType;
			const { vehicleTypes } = props;

			if (vehicleTypes) {
				for (let i = 0; i < vehicleTypes.length; ++i) {
					var checked = false;
					if (vehicleType) {
						for (let j = 0; j < vehicleType.length; ++j) {
							if (vehicleTypes[i].id === vehicleType[j]) {
								checked = true;
								break;
							}
						}
					}
					vehicleTypes[i].checked = checked;
				}
			}
		}


		if (
			(this.props.vehicleMakes &&
			this.props.filter.vehicleMake > 0 &&
			props.filter.vehicleMake !== this.props.filter.vehicleMake) || (this.props.filter.vehicleMake > 0 && props.filter.vehicleType != this.props.filter.vehicleType)
		) {
			getVehicleModel(this.props.filter.vehicleType, this.props.filter.vehicleMake, true).then((resp) => {
				if (resp.data.data) {
					this.setState({
						vehicleModels: resp.data.data.vehicleModels,
					});
				}
			});
		}
	}

	// UNSAFE_componentWillUnmount() {
	// 	// important
	// 	document.removeEventListener("click", this.handleClick);
	// }

	// handleClick = (e) => {

	// 	if (
	// 		this.wrapper.current &&
	// 		this.wrapperVM.current &&
	// 		this.wrapperFuel.current &&
	// 		this.wrapperTrans.current &&
	// 		e.target !== null &&
	// 		this.wrapperVMD.current == null
	// 	) {
	// 		if (
	// 			!this.wrapper.current.contains(e.target) &&
	// 			!this.wrapperVM.current.contains(e.target) &&
	// 			!this.wrapperTrans.current.contains(e.target) &&
	// 			!this.wrapperFuel.current.contains(e.target)
	// 		) {
	// 			this.onSlideChange();
	// 		}
	// 	}

	// 	if (
	// 		this.wrapperVMD.current &&
	// 		this.wrapper.current &&
	// 		this.wrapperVM.current &&
	// 		this.wrapperFuel.current &&
	// 		this.wrapperTrans.current &&
	// 		e.target !== null
	// 	) {
	// 		if (
	// 			!this.wrapperVMD.current.contains(e.target) &&
	// 			!this.wrapper.current.contains(e.target) &&
	// 			!this.wrapperVM.current.contains(e.target) &&
	// 			!this.wrapperTrans.current.contains(e.target) &&
	// 			!this.wrapperFuel.current.contains(e.target)
	// 		) {
	// 			this.onSlideChange();
	// 		}
	// 	}
	// };

	searchCar = (openModal) => {
		const { filter } = this.props;
		this.props.searchCar(filter);

		this.setState({
			[`${openModal}`]: false,
		});
	};

	onHandleShowBox = (name) => {
		this.setState({
			[`${name}`]: true,
		});
	}

	onCloseBox = (name) => {
		this.setState({
			[`${name}`]: false,
		});
	}

	// onHandleDropdown = (name, boolean) => {
	// 	this.checkOpenDropdown(name, boolean);
	// 	this.closeDropdownSibling(name);

	// 	this.setState({
	// 		[`${name}`]: boolean,
	// 	});
	// };

	// onCloseDropdown = (name) => {
	// 	this.setState({
	// 		[`${name}`]: false,
	// 	});
	// };

	// checkOpenDropdown = (name, boolean) => {
	// 	const dropdownName = ["isOpenVT", "isOpenVM", "isOpenVMD", "isOpenFuel", "isOpenTrans"];
	// 	const isInArray = dropdownName.includes(name);

	// 	if (isInArray && boolean === true) {
	// 		this.setState({
	// 			isDropdown: true,
	// 		});
	// 	} else {
	// 		this.setState({
	// 			isDropdown: false,
	// 		});
	// 	}
	// };

	// closeDropdownSibling = (name) => {
	// 	const dropdownName = ["isOpenVT", "isOpenVM", "isOpenVMD", "isOpenFuel", "isOpenTrans"];

	// 	for (let i = 0; i < dropdownName.length; i++) {
	// 		if (name !== dropdownName[i]) {
	// 			this.setState({
	// 				[`${dropdownName[i]}`]: false,
	// 			});
	// 		}
	// 	}
	// };

	onVTypeChange = (event) => {
		const { vehicleTypes } = this.props;
		const vehicleTypeId = event.target.value;
		const vehicleMake = this.props.filter.vehicleMake;
		let vehicleType = [];

		if (this.props.filter.vehicleType) {
			vehicleType = this.props.filter.vehicleType.slice();
		}

		if (event.target.checked) {
			vehicleType.push(vehicleTypeId);
		} else {
			vehicleType = vehicleType.filter((vType) => {
				return vType !== vehicleTypeId;
			});
		}

		for (var i = 0; i < vehicleTypes.length; ++i) {
			var checked = false;
			if (vehicleType) {
				for (var j = 0; j < vehicleType.length; ++j) {
					if (vehicleTypes[i].id === vehicleType[j]) {
						checked = true;
						break;
					}
				}
			}

			vehicleTypes[i].checked = checked;
		}

		if (vehicleMake > 0) {
			getVehicleModel(vehicleType, vehicleMake, true).then((resp) => {
				if (resp.data.data) {
					this.setState({
						vehicleModels: resp.data.data.vehicleModels,
					});
					const filter = {
						...this.props.filter,
						vehicleType: vehicleType,
						vehicleModel: [],
					};
					this.props.setFilter(filter);
					this.props.searchCar(filter);
				}
			});
		}
		this.setState({
			vehicleModels: null,
		});
		const filter = {
			...this.props.filter,
			vehicleType: vehicleType,
			vehicleModel: [],
		};

		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onVehicleMakesChange = (e) => {
		let vehicleMake = Number(e);

		if (vehicleMake > 0) {
			const vehicleType = this.props.filter.vehicleType;

			getVehicleModel(vehicleType, vehicleMake, true).then((resp) => {
				if (resp.data.data) {
					this.setState({
						vehicleModels: resp.data.data.vehicleModels,
					});
					const filter = {
						...this.props.filter,
						vehicleMake: vehicleMake,
						vehicleModel: [],
					};
					this.props.setFilter(filter);
					this.props.searchCar(filter);
				}
			});
		} else {
			this.setState({
				vehicleModels: null,
			});

			const filter = {
				...this.props.filter,
				vehicleMake: 0,
				vehicleModel: [],
			};

			this.props.setFilter(filter);
			this.props.searchCar(filter);
		}
	};

	showVehicleModels = () => {
		// this.closeVehicleMakes();

		this.setState({
			isOpenVehicleModels: true,
		});
	};

	closeVehicleModels = () => {
		this.setState({
			isOpenVehicleModels: false,
		});
	};

	onVehicleModelsChange = (value) => {
		let vehicleModel = [];
		let vehicleModelId = value;
		const { vehicleModels } = this.state;

		if (this.props.filter.vehicleModel) {
			vehicleModel = this.props.filter.vehicleModel.slice();
		}

		if (vehicleModel.includes(vehicleModelId)) {
			vehicleModel = vehicleModel.filter((vModel) => {
				return vModel !== vehicleModelId;
			});
		} else {
			vehicleModel.push(vehicleModelId);
		}

		for (var i = 0; i < vehicleModels.length; ++i) {
			var checked = false;
			if (vehicleModel) {
				for (var j = 0; j < vehicleModel.length; ++j) {
					if (vehicleModels[i].id === vehicleModel[j]) {
						checked = true;
						break;
					}
				}
			}

			vehicleModels[i].checked = checked;
		}

		const filter = {
			...this.props.filter,
			vehicleModel: vehicleModel,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onHandleCheckedBoxChange = (event) => {
		const filter = {
			...this.props.filter,
			[event.target.name]: event.target.checked,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onTransmissionChange = (event) => {
		const filter = {
			...this.props.filter,
			transmission: +event.target.value,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};
	
	onFuelElectric = (event) => {
		if (event.target.checked) {
			const filter = {
				...this.props.filter,
				fuel: 3,
			};
			this.props.setFilter(filter);
			this.props.searchCar(filter);
		} else {
			const filter = {
				...this.props.filter,
				fuel: 0,
			};
			this.props.setFilter(filter);
			this.props.searchCar(filter);
		}
	}

	onFuelChange = (event) => {
		const filter = {
			...this.props.filter,
			fuel: event.target.value,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	toggleFilterBox = () => {
		this.props.toggleFilterBox();
	};

	resetFilter = () => {
		this.props.resetFilter();
	};

	nextSlide = () => {
		const { swiperFilter } = this.state;

		swiperFilter.slideNext();
	};

	prevSlide = () => {
		const { swiperFilter } = this.state;

		swiperFilter.slidePrev();
	};

	onSlideChange = () => {
		this.setState({
			// isOpenVT: false,
			// isOpenVM: false,
			// isOpenVMD: false,
			// isOpenFuel: false,
			// isOpenTrans: false,
			isTooltip: false,
		});
	};

	onHoverTooltip = () => {
		this.setState({
			isTooltip: true
		})
	}

	onLeaveTooltip = () => {
		this.setState({
			isTooltip: false
		})
	}

	render() {
		const { filter, vehicleMakes, vehicleTypes, counters, customFilterConfig, isSD, viewMode, visible } = this.props;
		const {
			isOpenVehicleTypes,
			vehicleModels,
			activeVModel,
			isOpenVT,
			isOpenVM,
			isOpenVMD,
			isOpenTrans,
			isOpenFuel,
			isTooltip,
		} = this.state;

		var i, j, counter;

		if (counters) {
			if (vehicleTypes) {
				for (i = 0; i < vehicleTypes.length; ++i) {
					counter = 0;
					if (counters.vehicleTypes) {
						for (j = 0; j < counters.vehicleTypes.length; ++j) {
							if (vehicleTypes[i].id === counters.vehicleTypes[j].id) {
								counter = counters.vehicleTypes[j].counter;
								break;
							}
						}
					}
					vehicleTypes[i].counter = counter;
				}
			}

			if (vehicleMakes) {
				for (i = 0; i < vehicleMakes.length; ++i) {
					counter = 0;
					if (counters.vehicleMakes) {
						for (j = 0; j < counters.vehicleMakes.length; ++j) {
							if (vehicleMakes[i].id === counters.vehicleMakes[j].id) {
								counter = counters.vehicleMakes[j].counter;
								break;
							}
						}
					}
					vehicleMakes[i].counter = counter;
				}
			}
			if (vehicleModels) {
				for (i = 0; i < vehicleModels.length; ++i) {
					counter = 0;
					if (counters.vehicleModels) {
						for (j = 0; j < counters.vehicleModels.length; ++j) {
							if (vehicleModels[i].id === counters.vehicleModels[j].id) {
								counter = counters.vehicleModels[j].counter;
								break;
							}
						}
					}
					vehicleModels[i].counter = counter;
				}
			}
		}


		const hasFilter = this.props.hasFilter(filter, customFilterConfig);

		return (
			<div className={`filter-section ${viewMode === viewModes.LIST ? "fixed" : ""} ${visible ? "" : "scroll-top"}`}>
				<div className="m-container">
					<div className="filter-container">
						<div className="filter-dropdown">
							<div className="list-dropdown">
								<div
									className={`item-dropdown reset-item ${hasFilter ? "active rotate" : ""}`}
									onClick={this.resetFilter}>
									<div className="item-dropdown__wrap">
										<div className="wrap-svg">
											<IcResetFilter />
										</div>
									</div>
								</div>
									<Swiper
										modules={[Navigation]}
										navigation={{
											prevEl: ".filter-prev",
											nextEl: ".filter-next",
										}}
										breakpoints={{
											992: {
												slidesPerGroup: 3,
											},
											577: {
												slidesPerGroup: 2,
											},
										}}
										slidesPerGroup={1}
										spaceBetween={10}
										slidesPerView={"auto"}
										onSlideChange={() => {}}
										onSwiper={(swiper) => this.setState({ swiperFilter: swiper })}
										className={`swiper-list-filter ${isTooltip ? "show-dropdown" : ""}`}>
									<SwiperSlide>
										<div
											className={`item-dropdown ${
												filter.vehicleType && filter.vehicleType.length > 0 ? "active" : ""
											}`}>
											<div className="item-dropdown__wrap" onClick={() => this.onHandleShowBox("isOpenVT")}>
												<div className="wrap-svg">
													<IcVType />
												</div>
												<p>Loại xe </p>
												
											</div>
											{isOpenVT && (
												<VehicleTypesBox
													show={isOpenVT}
													vehicleTypes={vehicleTypes}
													onClose={this.onCloseBox}
													onVTypeChange={this.onVTypeChange}
												/>
											)}
										</div>
									</SwiperSlide>
									<SwiperSlide>
										<div
											className={`item-dropdown ${
												filter.vehicleMake != "0" ? "active" : ""
											}`}>
											<div className="item-dropdown__wrap" onClick={() => this.onHandleShowBox("isOpenVM")}>
												<div className="wrap-svg">
													<IcVMake />
												</div>
												<p>Hãng xe</p>
												
											</div>
											{isOpenVM && (
												<VehicleMakesBox
													show={isOpenVM}
													vehicles={vehicleMakes}
													onClose={this.onCloseBox}
													onVehiclesChange={this.onVehicleMakesChange}
													vehicleMake={this.props.filter.vehicleMake}
												/>
											)}
										</div>
									</SwiperSlide>

									{this.props.filter.vehicleMake > 0 && (
										<SwiperSlide>
											<div
												className={`item-dropdown ${
													filter.vehicleModel.length > 0 ? "active" : ""
												}`}>
												<div
													className="item-dropdown__wrap"
													onClick={() => this.onHandleShowBox("isOpenVMD")}>
													<div className="wrap-svg">
														<IcVModel />
													</div>
													<p>Mẫu xe</p>
												
												</div>
												{isOpenVMD && (
													<VehicleModelsBox
														show={isOpenVMD}
														vehicles={vehicleModels}
														onClose={this.onCloseBox}
														onVehiclesChange={this.onVehicleModelsChange}
													/>
												)}
											</div>
										</SwiperSlide>
									)}

									<SwiperSlide>
										<div className="item-dropdown custom-checkbox-selected">
											<input
												id="cb_owner5star"
												type="checkbox"
												name="ownerHostFiveStar"
												checked={filter.ownerHostFiveStar === true}
												onChange={this.onHandleCheckedBoxChange}
											/>
											<label htmlFor="cb_owner5star">
												<div className="item-dropdown__wrap" onMouseEnter={this.onHoverTooltip}  onMouseLeave={this.onLeaveTooltip}>
													<div className="wrap-svg">
														<IcOwner5Star />
													</div>
													<TooltipP 
														title={"Chủ xe 5 sao"} 
														desc={() => <>Chủ xe 5* có thời gian phản hồi nhanh chóng, tỉ lệ đồng ý cao và dịch vụ nhận được nhiều đánh giá tốt từ khách hàng </>}
														position={"bottom-right"} />
												</div>
											</label>
										</div>
									</SwiperSlide>

									<SwiperSlide>
										<div className="item-dropdown custom-checkbox-selected">
											<input
												id="cb_instant"
												type="checkbox"
												name="instantBooking"
												checked={filter.instantBooking === true}
												onChange={this.onHandleCheckedBoxChange}
											/>
											<label htmlFor="cb_instant">
												<div className="item-dropdown__wrap" onMouseEnter={this.onHoverTooltip}  onMouseLeave={this.onLeaveTooltip}>
													<div className="wrap-svg">
														<IcInstantLine />
													</div>
													<TooltipP 
														title={"Đặt xe nhanh"} 
														desc={() => <>Xe có thể đặt ngay lập tức mà không cần chủ xe phê duyệt (bạn cần đặt trước chuyến đi tối thiểu 6 tiếng)</>}
														position={"bottom"} />
												</div>
											</label>
										</div>
									</SwiperSlide>
							

									{isSD ? <SwiperSlide>
										<div className="item-dropdown custom-checkbox-selected">
											<input
												id="cb_mortgage"
												type="checkbox"
												name="nonMortgage"
												checked={filter.nonMortgage === true}
												onChange={this.onHandleCheckedBoxChange}
											/>
											<label htmlFor="cb_mortgage">
												<div className="item-dropdown__wrap" onMouseEnter={this.onHoverTooltip}  onMouseLeave={this.onLeaveTooltip}>
													<div className="wrap-svg">
														<IcNonMortgage />
													</div>
													<TooltipP 
														title={"Miễn thế chấp"} 
														desc={() => <>Chủ xe hỗ trợ chính sách <strong>miễn thế chấp.</strong> Khách hàng không cần để lại tài sản (xe máy hoặc 15tr tiền mặt) khi thuê xe của chủ xe.<br />Các phụ phí phát sinh (nếu có) trong quá trình thuê xe, khách hàng vui lòng thanh toán trực tiếp cho chủ xe khi làm thủ tục trả xe.</>}
														position={"bottom"} />
												</div>
											</label>
										</div>
									</SwiperSlide> : null}

									{isSD ? (
										<SwiperSlide>
											<div className="item-dropdown custom-checkbox-selected">
												<input
													id="cbInsurance"
													type="checkbox"
													name="supportIns"
													checked={filter.supportIns === true}
													onChange={this.onHandleCheckedBoxChange}
												/>
												<label htmlFor="cbInsurance">
													<div className="item-dropdown__wrap" onMouseEnter={this.onHoverTooltip}  onMouseLeave={this.onLeaveTooltip}>
														<div className="wrap-svg">
															<IcInsuranceLine />
														</div>
														<TooltipP 
															title={"Bảo hiểm chuyến đi"} 
															desc={() => <>Xe có đăng kí bảo hiểm thuê xe, trường hợp có sự cố tổn thất về xe trong thời gian thuê, tối đa bạn bồi thường 2 triệu đồng</>}
															position={"bottom"} 
														/>

													</div>
												</label>
											</div>
										</SwiperSlide>
									) : null}

									{isSD ? (
										<SwiperSlide>
											<div className="item-dropdown custom-checkbox-selected">
												<input
													id="cb_directDelivery"
													type="checkbox"
													name="directDelivery"
													checked={filter.directDelivery === true}
													onChange={this.onHandleCheckedBoxChange}
												/>
												<label htmlFor="cb_directDelivery">
													<div className="item-dropdown__wrap" onMouseEnter={this.onHoverTooltip}  onMouseLeave={this.onLeaveTooltip}>
														<div className="wrap-svg">
															<IcDelivery />
														</div>
														<TooltipP 
															title={"Giao nhận xe tận nơi"} 
															desc={() => <>Chủ xe có dịch vụ giao nhận xe tại nhà, sân bay hoặc các địa điểm bạn lựa chọn trong phạm vi nhất định tính từ vị trí của xe. Phí giao nhận bình quân từ 15-20k/km</>}
															position={"bottom"} />
													</div>
												</label>
											</div>
										</SwiperSlide>
									) : null}

								
									<SwiperSlide>
										<div className="item-dropdown custom-checkbox-selected">
											<input
												id="cb_discount"
												type="checkbox"
												name="discount"
												checked={filter.discount === true}
												onChange={this.onHandleCheckedBoxChange}
											/>
											<label htmlFor="cb_discount">
												<div className="item-dropdown__wrap" onMouseEnter={this.onHoverTooltip}  onMouseLeave={this.onLeaveTooltip}>
													<div className="wrap-svg">
														<IcDiscount />
													</div>
													<TooltipP 
														title={"Xe giảm giá"} 
														desc={() => <>Xe đang có chương trình giảm giá (không áp dụng đồng thời với các CTKM khác)</>}
														position={"bottom"} />
												</div>
											</label>
										</div>
									</SwiperSlide>

									<SwiperSlide>
										<div className="item-dropdown custom-checkbox-selected">
											<input
												id="cb_electric"
												type="checkbox"
												name="fuelElectric"
												checked={filter.fuel === 3}
												onChange={this.onFuelElectric}
											/>
											<label htmlFor="cb_electric">
												<div className="item-dropdown__wrap">
													<div className="wrap-svg">
														<IcElectricCar />
													</div>
													<p>Xe điện</p>
												</div>
											</label>
										</div>
									</SwiperSlide>

									<SwiperSlide>
										<div className={`item-dropdown ${
													filter.transmission ? "active" : ""
												}`}>
											<div
												className="item-dropdown__wrap"
												onClick={() => this.onHandleShowBox("isOpenTrans")}>
												<div className="wrap-svg">
													<IcTransmission />
												</div>
												<p>Truyền động</p>
												
											</div>
											{isOpenTrans && (
												<Transmision
													show={isOpenTrans}
													onTransmissionChange={this.onTransmissionChange}
													filter={filter.transmission}
													onClose={this.onCloseBox}
												/>
											)}
										</div>
									</SwiperSlide>

									{/* <SwiperSlide>
										<div className={`item-dropdown ${
													filter.fuel ? "active" : ""
												}`}>
											<div
												className="item-dropdown__wrap"
												onClick={() => this.onHandleShowBox("isOpenFuel")}>
												<div className="wrap-svg">
													<IcFuel />
												</div>
												<p>Nhiên liệu</p>
												
											</div>
											{isOpenFuel && (
												<Fuel show={isOpenFuel} onFuelChange={this.onFuelChange} filter={filter.fuel} onClose={this.onCloseBox} />
											)}
										</div>
									</SwiperSlide> */}
								</Swiper>

								<div className="swiper-button-prev filter-prev"></div>
								<div className="swiper-button-next filter-next"></div>
							</div>
							<a className={`btn`} onClick={() => this.toggleFilterBox()} style={{ backgroundColor: "#ffffff" }}>
								<div className="wrap-svg">
									<IcFilter3L />
								</div>
								Bộ lọc
							</a>
						</div>
					
					</div>
				</div>
			
			</div>
		);
	}
}

export default QuicklyFilter;
